/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { HallOfFameComponent } from './hall-of-fame.component';
import { CommunityModule } from '../common/community/community.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule,
    CommunityModule,
    SharedModule,
  ],
  declarations: [
    HallOfFameComponent,
  ],
  exports: [
    HallOfFameComponent,
  ],
})
export class HallOfFameModule {}
